import styled from "@emotion/styled";
import React, { useState } from "react";
import { Table, Modal } from "antd";
import { responsive } from "../../../utils/style";
import { css } from "@emotion/react";

import SummarySection from "./SummarySection";

import HINT_ICON from "../../../assets/icons/HintIcon.svg";

import { REWARDS } from "../../../utils/reward";
import RewardCard from "./RewardCard";
import { fontFamiliy } from "../constant";

const ResultTable = ({ columns, dataSource, mean, sd, median }) => {
  const [show, setShow] = useState(false);

  return (
    <TableContainer>
      <CustomTable
        dataSource={dataSource}
        columns={columns}
        bordered
        pagination={false}
        scroll={{ x: 2000, y: 500 }}
        summary={() => (
          <Table.Summary fixed>
            <SummarySection mean={mean} sd={sd} median={median} />
          </Table.Summary>
        )}
      />
      <RewardsHintButton onClick={() => setShow(true)}>
        <img src={HINT_ICON} width={"16px"} height={"16px"} />
        <RewardsHintLabel> ดูรายชื่อรางวัล</RewardsHintLabel>
      </RewardsHintButton>
      <Modal
        footer={null}
        title={null}
        visible={show}
        onCancel={() => setShow(false)}
      >
        <center>
          <ModalTitle>รายชื่อรางวัล</ModalTitle>
        </center>
        <ModalContentContainer>
          {REWARDS.map((r) => (
            <RewardCard imgName={r.image} code={r.code} name={r.name} />
          ))}
        </ModalContentContainer>
      </Modal>
    </TableContainer>
  );
};

export default ResultTable;

const ModalContentContainer = styled.div`
  margin-top: 16px;
`;

const ModalTitle = styled.span`
  font-family: ${fontFamiliy}
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height, or 140% */

  text-align: center;

  /* Primary/Green 500 */

  color: #058459;
`;

const RewardsHintButton = styled.div`
  cursor: pointer;
  margin-top: 8px;
`;
const RewardsHintLabel = styled.span`
  font-family: ${fontFamiliy}
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  /* identical to box height, or 162% */

  /* Primary/Green 500 */
  margin-left: 4px;

  color: #058459;
`;

const CustomTable = styled(Table)`
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td,
  .ant-table tfoot > tr > th,
  .ant-table tfoot > tr > td {
    position: relative;
    padding: 0;
    height: 36px;
    overflow-wrap: break-word;
    white-space: pre-line;

    font-family: ${fontFamiliy}
    font-style: normal;
    font-weight: 700;
    font-size: 13px;
    line-height: 14px;

    text-align: center;

    color: #4b5768;
  }

  .ant-table-header {
    border-left: 1px solid #4b5768;
    border-top: 1px solid #4b5768;
    border-right: 1px solid #4b5768;
    border-radius: 8px 8px 0px 0px;
  }

  .ant-table-body {
    border-left: 1px solid #4b5768;
    border-bottom: 1px solid #4b5768;
    border-right: 1px solid #4b5768;
    border-radius: 0px 0px 8px 8px;
  }

  *::-webkit-scrollbar {
    height: 15px !important;
  }
`;

const TableContainer = styled.div`
  border: 0px solid black;
  max-width: 911px;

  ${responsive.tablet(css`
    max-width: calc(100vw - 32px);
    margin: auto;
  `)}
`;
